import React from "react";
import styled from "styled-components/macro";
import Hero from "src/components/Hero/Hero";
import { t } from "i18next";
import { Row, Col } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import PgCard from "src/components/Card/PgCard";
import EventFinished from "src/components/EventFinished";

const HauntedCarnival2025 = () => {
  const contentItems = t("hauntedCarnival2025.content.features", {
    returnObjects: true,
  });

  return (
    <>
      <HauntedCarnivalDiv>
        <EventFinished
          scheduleKeyName="hauntedCarnival2025"
          eventType="promotion"
        />
        <Hero
          arrowBounce="true"
          bgImage="promotions/gaming-machines/haunted-carnival-2025/v2/Halloween-2025-hero-image-2400x800px.jpg"
          image={t("hauntedCarnival2025.hero.image")}
          imageAlt={t("hauntedCarnival2025.hero.imageAlt")}
          buttonLink=""
          buttonText=""
          descriptionBgColor="none"
        />
        <container-div>
          <ReactMarkdown className="main-description">
            {t("hauntedCarnival2025.content.description")}
          </ReactMarkdown>
          <div className="grid-content">
            <Row>
              {Object.values(contentItems)?.map((item, index) => (
                <Col xs={12} md={6} lg={4} key={item.id || index}>
                  <PgCard
                    image={item.image}
                    imageAlt={item.title}
                    title={item.title}
                    text={item.description}
                    variant="portrait"
                    className={`highlight-${item.color}`}
                  />
                </Col>
              ))}
            </Row>
          </div>
        </container-div>
      </HauntedCarnivalDiv>
    </>
  );
};

const HauntedCarnivalDiv = styled.div`
  background: #121212;
  text-align: center;
  display: flex;
  flex-direction: column;
  color: var(--white);

  .hero_container {
    .hero_image_container {
      padding: 2rem 1rem;
    }
  }
  .hero_text_container {
    display: none;
  }
  .pg-card {
    display: block;
    flex-direction: column;
    height: 100%;
    max-height: none;
    padding-bottom: 2rem;;
    .card-image-top {
      width: 100%;
      height: 290px;
      display: block;
    }
    &.highlight-21aeee .h5 {
      color: #21aeee;
    }
    &.highlight-a23896 .h5 {
      color: #a23896;
    }
    &.highlight-ed1c24 .h5 {
      color: #ed1c24;
    }
    max-height: 500px;
    max-width: auto;
    /* margin: 20px 10px; */
    position: unset;

    .card-text-wrapper {
      position: static !important;
      top: 0;
      bottom: auto;
      left: auto;
      margin: 0.75rem auto 0;
      width: 90%;
      text-align: center;
      .card-header {
        border-bottom: none;
        background-color: transparent;
      }


      .card-body {
        padding-top: 0;
      }

      .card-title {
        margin: 10px 0;
      }

      .card-body {
        background: transparent;
      }
    }
  }
  .main-description {
    text-align: center;
    margin:3rem auto 0;
    max-width: 800px;
    p {
      font-size: 1.2rem;
      line-height: 1.4;
      margin-bottom: 1.5rem;
    }
  }
  .grid-content {
    margin-top: 2rem;
  }
`;

export default HauntedCarnival2025;